export default __webpack_public_path__ + "static/media/whiteloader.4b178b5a.svg";